import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number | string;
  newPrefs: Record<string, boolean>;
};

const [useUpdateSpaceNotifications, updateSpaceNotifications] = createAsyncAction(
  "spaces/updateSpaceNotifications",
  async ({ spaceId, newPrefs }: Args) => {
    const res = await API.call<{ member: string }>({
      endpoint: `me/spaces/${spaceId}/notification-prefs${window.location.search}`,
      method: "PUT",
      data: newPrefs,
    });
    return { ...res, result: res.result.member };
  }
);

export default useUpdateSpaceNotifications;
export { updateSpaceNotifications };
